//rolePermission
export const rolePermissionUrl = '/app/menu-role-permission'
export const getRolePermissionPage = () => `${rolePermissionUrl}/by-role-menu-id`
export const saveRolePermission = () => `${rolePermissionUrl}/batch-upsert`
export const getRoleMenu = () => `/app/menu/current-menu-tree-extend-by-role-name`
export const getCurrentUserMenuRolePermissions = () =>
  `${rolePermissionUrl}/current-user-menu-role-permissions`
